"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var WebSocketManager_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketEvent = exports.CloseEventCode = exports.WebSocketManager = void 0;
const auth_1 = require("@completeanatomy/auth");
const config_1 = require("@completeanatomy/config");
const event_bus_1 = require("@completeanatomy/event-bus");
const eventemitter3_1 = require("eventemitter3");
require("reflect-metadata");
const typedi_1 = require("typedi");
const types_1 = require("./types");
Object.defineProperty(exports, "CloseEventCode", { enumerable: true, get: function () { return types_1.CloseEventCode; } });
Object.defineProperty(exports, "WebSocketEvent", { enumerable: true, get: function () { return types_1.WebSocketEvent; } });
/**
 * Manager of WebSocket connection to server
 */
let WebSocketManager = WebSocketManager_1 = class WebSocketManager extends eventemitter3_1.EventEmitter {
    constructor(config, auth, eventBus) {
        super();
        this.config = config;
        this.auth = auth;
        this.eventBus = eventBus;
        /**
         * ID of reconnect timeout
         *
         * @private
         */
        this.reconnectTimeout = null;
        this.eventBus.on(event_bus_1.AuthEvent.Authenticated, () => this.init(), this);
        this.eventBus.on(event_bus_1.AuthEvent.NeedClearUserData, () => this.close(types_1.CloseEventCode.NormalClosure), this);
        this.eventBus.on(event_bus_1.AuthEvent.AccessTokenWasRefreshed, this.handleAccessTokenRefresh, this);
    }
    /**
     * Initialises WebSocket connection
     */
    init() {
        var _a, _b;
        if (!this.auth.isAuthenticated() ||
            ((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CONNECTING ||
            ((_b = this.websocket) === null || _b === void 0 ? void 0 : _b.readyState) === WebSocket.OPEN) {
            return;
        }
        const websocketUrl = this.config.get('SOCKET_URL');
        const accessToken = this.config.get('accessToken');
        this.websocket = new WebSocket(`${websocketUrl}?authorization=${accessToken}`);
        this.websocket.addEventListener(types_1.WebSocketEvent.Open, (event) => {
            if (this.reconnectTimeout !== null) {
                window.clearTimeout(this.reconnectTimeout);
                this.reconnectTimeout = null;
            }
            this.emit(types_1.WebSocketEvent.Open, event);
        }, false);
        this.websocket.addEventListener(types_1.WebSocketEvent.Message, (event) => {
            const data = JSON.parse(event.data);
            this.emit(data.action, data);
        }, false);
        this.websocket.addEventListener(types_1.WebSocketEvent.Error, (event) => {
            this.emit(types_1.WebSocketEvent.Error, event);
            if (this.reconnectTimeout !== null) {
                return;
            }
            /**
             * Reconnect to the server after RECONNECT_INTERVAL
             */
            this.reconnectTimeout = window.setTimeout(() => {
                this.init();
            }, WebSocketManager_1.RECONNECT_INTERVAL);
        }, false);
        this.websocket.addEventListener(types_1.WebSocketEvent.Close, (event) => {
            this.emit(types_1.WebSocketEvent.Close, event);
            if (event.code === types_1.CloseEventCode.Unauthorized &&
                this.auth.isAuthenticated()) {
                this.auth.refresh();
            }
        }, false);
    }
    /**
     * Send a message to the server
     *
     * @param data - sending data
     */
    send(data) {
        var _a;
        (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.send(data);
    }
    /**
     * Close WebSocket connection to the server
     *
     * @param code - exit code
     */
    close(code) {
        var _a;
        (_a = this.websocket) === null || _a === void 0 ? void 0 : _a.close(code);
    }
    /**
     * Close current connection with an old access token and open it again with a new one
     *
     * @private
     */
    handleAccessTokenRefresh() {
        var _a;
        if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket.CLOSED) {
            this.close(types_1.CloseEventCode.NormalClosure);
        }
        this.init();
    }
};
exports.WebSocketManager = WebSocketManager;
/**
 * Name of exported module property
 */
WebSocketManager.exportName = 'websocket';
/**
 * Interval between close and reopen websocket connection
 * @private
 */
WebSocketManager.RECONNECT_INTERVAL = 60000;
exports.WebSocketManager = WebSocketManager = WebSocketManager_1 = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [config_1.Config,
        auth_1.Auth,
        event_bus_1.EventBus])
], WebSocketManager);
